import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../common.module.scss";
import UserProfileIcon from "../../../shared/icons/UserProfileIcon";
import TransportCoveredIconNew from "../../../shared/icons/TransportCoveredIconNew";
import moment from "moment";

const OrdersDriverInfoShare = ({ item, vehicle }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(style.cargo_wrapper)}>
      <div className={cn(style.cargo_title, style.orders_title)}>
        {t("orderInfo.ordersDriverInfo.executorTitle")}
      </div>
      <div className={style.driver_content}>
        <div className={style.driver_details}>
          <div className={style.driver_details_text}>{t("orderInfo.ordersDriverInfo.driverLabel")}</div>
          <div className={style.driver_details_content}>
            <div className={style.driver_details_icon}>
              <UserProfileIcon />
            </div>
            <div className={style.driver_details_info}>
              <div className={style.driver_details_title}>
                {item?.surname ? `${item.name}.${item.surname.charAt(0).toUpperCase()}` : item?.name || ""}
              </div>
              <div className={style.driver_details_text}>
                {t("orderInfo.ordersDriverInfo.iinLabel")} {item?.iin ? item.iin : "-"}
              </div>
            </div>
          </div>
        </div>
        <div className={style.driver_details}>
          <div className={style.driver_details_text}>{t("orderInfo.ordersDriverInfo.transportLabel")}</div>
          <div className={style.driver_details_content}>
            <div className={style.driver_details_icon}>
              <TransportCoveredIconNew />
            </div>
            <div className={style.driver_details_info}>
              <div className={style.driver_details_title}>{vehicle?.carModel}</div>
              <div className={style.driver_details_text}>{vehicle?.carNumber}</div>
            </div>
          </div>
        </div>
        <div className={style.driver_details}>
          <div className={style.driver_details_text}>{t("orderInfo.ordersDriverInfo.documentsLabel")}</div>
          <div className={style.driver_details_info}>
            <div className={style.driver_details_title}>{t("orderInfo.ordersDriverInfo.idCardLabel")}</div>
            <div className={style.driver_details_text}>
              №{item?.idNumber}・{moment(item?.issuedDate).format("DD MMMM YYYY")}・{item?.issuedBy}
            </div>
          </div>
        </div>
        <div className={style.driver_details}>
          <div className={style.driver_details_text}>{t("driversHead.phoneNumber")}</div>
          <div className={style.driver_details_title}>{item?.phoneNumber ? +`${item.phoneNumber}` : "-"}</div>
        </div>
        {item?.vehicleType && (
          <div className={style.driver_details}>
            <div className={style.driver_details_text}>{t("carsCreatePage.vehicleType.label")}</div>
            <div className={style.driver_details_title}>{item?.vehicleType}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersDriverInfoShare;
